interface IconProps {
  size?: number;
  color?: string;
}

export function WatchIcon({ size = 24, color = 'currentColor' }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <rect x="6" y="6" width="12" height="12" rx="3" />
      <path d="M9 6V3h6v3" />
      <path d="M9 18v3h6v-3" />
      <circle cx="12" cy="12" r="2" />
      <line x1="12" y1="10" x2="12" y2="12" />
    </svg>
  );
}
